export default "__VITE_ASSET__TsYB$poT__"